import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { easeOut, staggerDelay } from '../../utils/motion';
import type { Product } from '../../types/catalog';
import { ProductCard } from './ProductCard';
interface ProductGridProps {
  products: Product[];
  columns?: 3 | 4;
}
export function ProductGrid({
  products,
  columns = 4
}: ProductGridProps) {
  const reduce = useReducedMotion();
  const cols = columns === 4 ? 'lg:grid-cols-4' : 'lg:grid-cols-3';
  return <ul className={`grid grid-cols-2 gap-x-4 gap-y-10 md:grid-cols-3 md:gap-x-6 ${cols}`} data-id="element-565" data-mp="1l2vp5r88722k">
      <AnimatePresence mode="popLayout" initial={true} data-id="element-566" data-mp="17346hd6rkxi8">
        {products.map((p, i) => <motion.li key={p.id} layout={!reduce} initial={reduce ? false : {
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.28,
        ease: easeOut,
        delay: staggerDelay(i)
      }} data-id="element-567" data-mp="1c1fhvscpjg2k" data-mpi={i}>
            <ProductCard product={p} data-id="element-568" data-mp="37sxsnxj8g49x" />
          </motion.li>)}
      </AnimatePresence>
    </ul>;
}